module.exports = __webpack_public_path__ + "static/media/HCMM463.af5975d9.jpg";